import { ProjectTypeGuard } from "features/ProjectType/presentation/components/ProjectTypeState";
import Page from "features/ProjectType/presentation/pages/ProjectTypeList";
export default function ProjectTypePage() {
  return (
    <ProjectTypeGuard>
      <Page />
    </ProjectTypeGuard>
  );
}
